import { isAtlassianEmployee } from './date-time-util/isAtlassianEmployee';

/**
 * Returns true when we should show the opt-in prompt for conversation history.
 * Requires: internal user + feature gate ON.
 */
export const shouldShowOptInPrompt = (email?: string): boolean => !!isAtlassianEmployee(email);
